import React, { useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';

import Button from "components/CustomButtons/Button.jsx";

const csvColumns = (columns) => columns.filter(c => c.active);

const OrderCSV = ({ rows, columns: allColumns }) => {
    const [columns, setColumns] = useState(csvColumns(allColumns));

    useEffect(() => {
        setColumns(csvColumns(allColumns))
    }, [allColumns]);

    // console.log(rows, columns);
    return (
        <Button color='primary' component={CSVLink} headers={columns} data={rows} style={{ color: 'white' }}>
            CSV
        </Button>
    )
};

export default OrderCSV;


// WEBPACK FOOTER //
// ./src/components/CSV/OrderCSV.jsx